import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Longtermcorporatecabservice() {



  const cardData =
  {
    keyword: 'Long-Term Corporate Cab Rentals in Delhi',
    heading: 'Aaryan Travels: Long-Term Corporate Cab Rentals in Delhi',
    headingDescription: 'Aaryan Travels offers Long-Term Corporate Cab Rentals in Delhi for companies, executives, and employees who require dedicated transportation on a monthly or yearly basis. Whether it’s daily employee commute, executive vehicle allocation, airport transfers from IGI Airport, or intercity corporate travel to Gurgaon, Noida, or Faridabad, our fleet of sedans, SUVs, and premium vehicles provides a reliable and professional mobility solution. With uniformed chauffeurs, GPS-enabled cars, punctual reporting, and transparent billing plans, we ensure seamless long-term transportation across Connaught Place, Okhla, Aerocity, and Cyber City. Aaryan Travels eliminates the hassle of daily bookings by delivering structured long-term corporate cab rental plans in Delhi.',

    top: 'Top Places to Visit in Delhi with Aaryan Travels',

"topPlaces": [
  {
    "title": "Red Fort (Lal Qila)",
    "description": "Built in 1648 by Emperor Shah Jahan, the Red Fort is a UNESCO World Heritage Site and a symbol of India’s independence. Its massive red sandstone walls, grand gateways, and Mughal-era palaces showcase rich architectural brilliance. The evening light-and-sound show narrates the fort’s history. Every Independence Day, the Prime Minister delivers a speech from its ramparts. Red Fort is Delhi’s proud emblem of history and freedom."
  },
  {
    "title": "India Gate",
    "description": "India Gate is a 42-meter-tall war memorial dedicated to Indian soldiers who sacrificed their lives in World War I. Surrounded by lush lawns, it is a popular spot for walks and picnics. The eternal flame, Amar Jawan Jyoti, burns in honor of fallen heroes. Illuminated beautifully at night, it becomes a dazzling landmark. India Gate is Delhi’s patriotic heart of tribute and remembrance."
  },
  {
    "title": "Qutub Minar",
    "description": "Qutub Minar, standing at 73 meters, is the tallest brick minaret in the world and a UNESCO World Heritage Site. Built in 1193, it features intricate carvings and Arabic inscriptions. The surrounding Qutub Complex includes ancient mosques and the legendary Iron Pillar. Qutub Minar is Delhi’s towering masterpiece of medieval engineering."
  },
  {
    "title": "Lotus Temple",
    "description": "Shaped like a blooming lotus, the Lotus Temple is a Bahá’í House of Worship open to people of all religions. Made of white marble, it exudes serenity with its peaceful ambiance and lush gardens. No rituals or ceremonies are held—only meditation and silence. Lotus Temple is Delhi’s modern symbol of unity and tranquility."
  },
  {
    "title": "Humayun’s Tomb",
    "description": "Built in 1570, Humayun’s Tomb is the first garden-tomb in India and a precursor to the Taj Mahal. Its symmetrical design, red sandstone structure, and Persian-style charbagh gardens make it a visual delight. Birds and greenery add to the serene atmosphere. Humayun’s Tomb is Delhi’s elegant tribute to Mughal heritage."
  },
  {
    "title": "Akshardham Temple",
    "description": "Akshardham Temple is a grand spiritual and cultural complex known for its stunning carvings, exhibitions, and musical fountain show. Built entirely from sandstone and marble without steel, it displays over 20,000 sculptures. The boat ride inside narrates India’s ancient innovations. Akshardham is Delhi’s breathtaking showcase of devotion and artistry."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid is one of India’s largest mosques, built by Shah Jahan in 1656. Its expansive courtyard can accommodate over 25,000 worshippers. The mosque’s red sandstone and marble architecture is magnificent. Visitors climb the minaret for panoramic city views. Jama Masjid is Delhi’s grand center of faith and heritage."
  },
  {
    "title": "Raj Ghat",
    "description": "Raj Ghat is a simple black marble memorial built at the cremation site of Mahatma Gandhi. Inscribed with his last words, 'Hey Ram', it symbolizes peace and humility. The surrounding garden and eternal flame offer a serene space for reflection. Raj Ghat is Delhi’s heartfelt homage to the Father of the Nation."
  },
  {
    "title": "Hauz Khas Village",
    "description": "Hauz Khas Village is a unique blend of 14th-century ruins, scenic lake views, and trendy cafes. Visitors explore the Hauz Khas Fort by day and enjoy vibrant nightlife after sunset. Art galleries, boutiques, and rooftop restaurants make it a popular youth destination. Hauz Khas is Delhi’s fusion of history and modern lifestyle."
  },
  {
    "title": "Chandni Chowk & Paranthe Wali Gali",
    "description": "Chandni Chowk is one of Delhi’s oldest and busiest markets known for spices, fabrics, and jewelry. Narrow lanes are filled with rickshaws, vendors, and traditional shops. Paranthe Wali Gali is famous for its stuffed parathas served with tangy pickles. The aroma of jalebi and kebabs fills the air. Chandni Chowk is Delhi’s chaotic yet delightful cultural maze."
  }
],


"services": [
  {
    "name": "Long-Term Corporate Cab Rentals in Delhi",
    "description": "Long-Term Corporate Cab Rentals in Delhi offer businesses sustainable and efficient transportation solutions tailored for extended durations. This service ensures consistent availability of well-maintained vehicles driven by professional chauffeurs, providing reliability, comfort, and safety for employees and clients over prolonged periods. Flexible rental terms and customizable packages help companies manage transportation budgets while maintaining high standards of service throughout the rental period."
  },
  {
    "name": "Delhi Long Term Corporate Cab",
    "description": "Delhi Long Term Corporate Cab service specializes in providing businesses with dedicated vehicles and experienced drivers for long-term corporate travel. Perfect for daily employee commutes, client transfers, and executive travel, this service ensures punctuality, professionalism, and seamless coordination."
  },
  {
    "name": "Corporate Cab Subscription Delhi",
    "description": "Corporate Cab Subscription Delhi simplifies corporate transportation through subscription-based models, offering convenience, budget control, and guaranteed availability of premium cabs. Companies benefit from streamlined booking processes and reliable service tailored to their specific needs."
  },
  {
    "name": "Office Transport Delhi Long Term",
    "description": "Office Transport Delhi Long Term focuses on providing dependable long-term transportation for employees. Designed to enhance workforce productivity and satisfaction, this service offers timely pickups and drop-offs, ensuring smooth daily commutes with attention to safety and comfort."
  },
  {
    "name": "Staff Cab Delhi Long Term",
    "description": "Staff Cab Delhi Long Term provides affordable and reliable long-duration cab services specifically for staff transportation. With a range of vehicle options and professional drivers, this service supports businesses in managing employee logistics efficiently."
  },
  {
    "name": "Chauffeur Corporate Cab Delhi",
    "description": "Chauffeur Corporate Cab Delhi offers premium chauffeur-driven vehicles ideal for corporate clients who value professionalism, discretion, and comfort. Our trained chauffeurs ensure a smooth travel experience, whether for executive meetings or regular business travel."
  },
  {
    "name": "Executive Corporate Cab Delhi",
    "description": "Executive Corporate Cab Delhi caters to senior executives and VIPs requiring luxurious and timely transportation. Featuring high-end vehicles and professional drivers, this service combines comfort with discretion for an exceptional corporate travel experience."
  },
  {
    "name": "Affordable Long Term Corporate Cab Delhi",
    "description": "Affordable Long Term Corporate Cab Delhi delivers cost-effective transportation solutions for businesses without compromising on quality or professionalism. Transparent pricing and flexible plans make this service ideal for companies seeking budget-friendly long-term options."
  },
  {
    "name": "Company Taxi Delhi Long Term",
    "description": "Company Taxi Delhi Long Term provides businesses with reliable taxi services over extended periods, ensuring efficient employee and client transportation. The service includes well-maintained vehicles and experienced drivers focused on safety and punctuality."
  },
  {
    "name": "Corporate Vehicle Rental Delhi",
    "description": "Corporate Vehicle Rental Delhi offers a broad fleet of vehicles suitable for various corporate travel requirements, available for long-term rental. Vehicles are equipped with modern amenities and driven by skilled chauffeurs to support business operations."
  },
  {
    "name": "Corporate Car Leasing Delhi",
    "description": "Corporate Car Leasing Delhi provides flexible leasing options designed for companies needing dedicated vehicles with maintenance and driver services included. This hassle-free solution supports long-term transportation needs efficiently."
  },
  {
    "name": "Monthly Business Cab Delhi",
    "description": "Monthly Business Cab Delhi delivers consistent, monthly cab rental services tailored to business travel needs. The service ensures availability of clean, comfortable vehicles and professional drivers to support daily commutes and corporate events."
  },
  {
    "name": "Long Term Staff Cab Delhi",
    "description": "Long Term Staff Cab Delhi specializes in affordable, reliable transportation for staff over extended durations. This service aims to streamline employee logistics while ensuring safety, punctuality, and comfort."
  },
  {
    "name": "Online Corporate Cab Delhi",
    "description": "Online Corporate Cab Delhi offers a convenient digital platform for booking and managing long-term corporate cab rentals. Features include instant confirmations, ride tracking, and flexible scheduling, empowering businesses to efficiently control their transportation needs."
  },
  {
    "name": "Premier Corporate Cab Delhi",
    "description": "Premier Corporate Cab Delhi provides top-tier corporate transportation services emphasizing luxury, professionalism, and reliability. Tailored for executives and VIP clients, this service ensures a premium travel experience with exceptional customer care."
  }
],
"tableData": [
  ["Long-Term Corporate Cab Rentals in Delhi", "Delhi Long Term Corporate Cab"],
  ["Corporate Cab Subscription Delhi", "Office Transport Delhi Long Term"],
  ["Staff Cab Delhi Long Term", "Chauffeur Corporate Cab Delhi"],
  ["Executive Corporate Cab Delhi", "Affordable Long Term Corporate Cab Delhi"],
  ["Company Taxi Delhi Long Term", "Corporate Vehicle Rental Delhi"],
  ["Corporate Car Leasing Delhi", "Monthly Business Cab Delhi"],
  ["Long Term Staff Cab Delhi", "Online Corporate Cab Delhi"],
  ["Premier Corporate Cab Delhi", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Long-Term Corporate Cab Rentals in Delhi",
    "WhyChoosedescription": "Aaryan Travels offers flexible long-term corporate cab rentals in Delhi for hassle-free business travel."
  },
  {
    "WhyChooseheading": "Reliable and Professional Chauffeurs",
    "WhyChoosedescription": "Our skilled drivers ensure punctual pickups and drop-offs to keep your corporate commitments on schedule."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, sanitized, and air-conditioned cabs maintained for safety and comfort over long periods."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Delhi Routes",
    "WhyChoosedescription": "Our drivers have expert knowledge of Delhi's roads and traffic for smooth and efficient travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear, upfront pricing that includes fuel, tolls, and driver allowances for worry-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Service",
    "WhyChoosedescription": "Our support team is available around the clock to assist you with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans Tailored to Your Needs",
    "WhyChoosedescription": "Choose long-term plans customized to your corporate travel requirements."
  },
  {
    "WhyChooseheading": "Wide Selection of Vehicle Options",
    "WhyChoosedescription": "Select from sedans, SUVs, and luxury vehicles to match your business travel preferences."
  }
]














  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer long-term corporate cab rentals in Delhi?',
    answer: 'Yes, Aaryan Travels provides flexible and cost-effective long-term corporate cab rental plans in Delhi, perfect for extended business travel needs.',
  },
  {
    question: 'How can I book long-term corporate cab rentals in Delhi with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our dedicated 24x7 corporate customer support team.',
  },
  {
    question: 'What vehicle options are available for long-term corporate rentals in Delhi?',
    answer: 'Aaryan Travels offers a variety of vehicles including sedans, SUVs, and premium cars to suit your corporate requirements.',
  },
  {
    question: 'Are the drivers experienced for long-term corporate cab services in Delhi?',
    answer: 'Absolutely. Our drivers are professional, licensed, and well-trained to provide safe and punctual service throughout your rental period.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for long-term corporate cab rentals?',
    answer: 'Yes, pickup and drop-off points can be tailored anywhere within Delhi and nearby business hubs according to your needs.',
  },
  {
    question: 'Is long-term corporate cab rental service available 24x7 in Delhi?',
    answer: 'Yes, Aaryan Travels operates round-the-clock to support your business schedules and shift requirements.',
  },
  {
    question: 'Are safety and hygiene protocols followed during long-term rentals?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict hygiene and safety protocols to ensure your well-being.',
  },
  {
    question: 'What payment options are available for long-term corporate cab rentals in Delhi?',
    answer: 'We accept payments via corporate accounts, digital wallets, UPI, credit/debit cards, and bank transfers.',
  },
  {
    question: 'Is customer support available throughout the long-term rental period?',
    answer: 'Yes, our 24x7 customer support team is available to assist you during your entire rental duration.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Verma',
    feedback: 'Aaryan Travels provided excellent long-term corporate cab service in Delhi. The drivers were professional and the vehicles well-maintained.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Sharma',
    feedback: 'The long-term corporate rental plan from Aaryan Travels helped us efficiently manage our employee transport in Delhi. Highly recommend!',
    rating: 5,
  },
];


























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const longTermCorporateCabDelhiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Long-Term Corporate Cab Rentals in Delhi",
  "description": "Aaryan Travels offers affordable long-term corporate cab rentals in Delhi including chauffeur-driven executive and staff transportation with flexible subscription plans.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Delhi"
  },
  "serviceType": "Long-Term Corporate Cab Rental Service",
  "keywords": "Long-Term Corporate Cab Rentals in Delhi, Delhi Long Term Corporate Cab, Corporate Cab Subscription Delhi, Office Transport Delhi Long Term, Staff Cab Delhi Long Term, Chauffeur Corporate Cab Delhi, Executive Corporate Cab Delhi, Affordable Long Term Corporate Cab Delhi, Company Taxi Delhi Long Term, Corporate Vehicle Rental Delhi, Corporate Car Leasing Delhi, Monthly Business Cab Delhi, Long Term Staff Cab Delhi, Online Corporate Cab Delhi, Premier Corporate Cab Delhi"
};







  return (
    <div>

<Helmet>
  <title>Long-Term Corporate Cab Rentals in Delhi | Affordable Executive Transport | Aaryan Travels</title>
  <meta
    name="description"
    content="Book long-term corporate cab rentals in Delhi with chauffeur-driven executive and staff transport services by Aaryan Travels. Flexible plans and affordable rates."
  />
  <meta
    name="keywords"
    content="Long-Term Corporate Cab Rentals in Delhi, Delhi Long Term Corporate Cab, Corporate Cab Subscription Delhi, Office Transport Delhi Long Term, Staff Cab Delhi Long Term, Chauffeur Corporate Cab Delhi, Executive Corporate Cab Delhi, Affordable Long Term Corporate Cab Delhi, Company Taxi Delhi Long Term, Corporate Vehicle Rental Delhi, Corporate Car Leasing Delhi, Monthly Business Cab Delhi, Long Term Staff Cab Delhi, Online Corporate Cab Delhi, Premier Corporate Cab Delhi"
  />
  <script type="application/ld+json">
    {JSON.stringify(longTermCorporateCabDelhiSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/66.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Longtermcorporatecabservice;